import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Cart = () => {
    const { cartItems, removeFromCart, updateQuantity, getCartTotal, getCartCount, clearCart } = useCart();
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });

    const showNotification = (message, type = 'success') => {
        setNotification({ show: true, message, type });
        setTimeout(() => {
            setNotification({ show: false, message: '', type: '' });
        }, 2000);
    };

    const handleRemoveItem = (item) => {
        removeFromCart(item.id);
        showNotification(`${item.name} removed from cart`, 'info');
    };

    const handleClearCart = () => {
        if (window.confirm('Are you sure you want to clear your cart?')) {
            clearCart();
            showNotification('Cart cleared successfully', 'info');
        }
    };

    if (cartItems.length === 0) {
        return (
            <section className="cart-pg-sc">
                <div className="container-fluid ps-5 pe-5">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="shedule-head">
                                <div className="un-head wow bounceInUp">
                                    <h3>SHOPPING CART</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="empty-cart">
                                <i className="fas fa-shopping-cart"></i>
                                <h4>Your cart is empty</h4>
                                <p>Add some items to get started</p>
                                <Link to="/shop" className="shop-btn">
                                    Continue Shopping <i className="fas fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="cart-pg-sc">
            {notification.show && (
                <div className={`cart-notification ${notification.type}`}>
                    <i className={`fas ${notification.type === 'success' ? 'fa-check-circle' : 'fa-info-circle'}`}></i>
                    <span>{notification.message}</span>
                </div>
            )}
            <div className="container-fluid ps-5 pe-5">
                <div className="row">
                    <div className="col-md-12">
                        <div className="shedule-head">
                            <div className="un-head wow bounceInUp">
                                <h3>SHOPPING CART ({getCartCount()} {getCartCount() === 1 ? 'item' : 'items'})</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="cart-items">
                            {cartItems.map((item) => (
                                <div key={item.id} className="cart-item">
                                    <div className="cart-item-image">
                                        <img src={item.image} alt={item.name} />
                                    </div>
                                    <div className="cart-item-details">
                                        <h6>{item.name}</h6>
                                        <p className="cart-item-price">
                                            £{item?.price ? Number(item.price).toFixed(2) : "0.00"} each
                                        </p>
                                    </div>
                                    <div className="cart-item-quantity">
                                        <button
                                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                            className="qty-btn"
                                            disabled={item.quantity <= 1}
                                        >
                                            <i className="fas fa-minus"></i>
                                        </button>
                                        <span className="qty-value">{item.quantity}</span>
                                        <button
                                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                            className="qty-btn"
                                        >
                                            <i className="fas fa-plus"></i>
                                        </button>
                                    </div>
                                    <div className="cart-item-total">
                                        <p>£{(item.price * item.quantity).toFixed(2)}</p>
                                    </div>
                                    <button
                                        onClick={() => handleRemoveItem(item)}
                                        className="cart-item-remove"
                                        title="Remove item"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="cart-actions">
                            <Link to="/shop" className="continue-shopping">
                                <i className="fas fa-arrow-left"></i> Continue Shopping
                            </Link>
                            <button onClick={handleClearCart} className="clear-cart-btn">
                                <i className="fas fa-trash-alt"></i> Clear Cart
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="cart-summary">
                            <h5>Order Summary</h5>
                            <div className="summary-row">
                                <span>Subtotal</span>
                                <span>£{getCartTotal().toFixed(2)}</span>
                            </div>
                            <div className="summary-row">
                                <span>Shipping</span>
                                <span className="free-shipping">FREE</span>
                            </div>
                            <div className="summary-divider"></div>
                            <div className="summary-row total">
                                <span>Total</span>
                                <span>£{getCartTotal().toFixed(2)}</span>
                            </div>
                            <Link to="/checkout" className="checkout-btn">
                                Proceed to Checkout <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Cart;
